import { Controller } from '@hotwired/stimulus';
import { convertToCurrency } from './currency';

export default class extends Controller {
  static targets = [
    'waiting',
    'walletBalance',
    'walletAmount',
    'bankTransfer',
    'transferAmount',
    'transferBeneficiary',
    'transferIban',
    'transferBic',
    'beneficiaryCopy',
    'ibanCopy',
    'bicCopy',
  ];

  connect() {
    this.#showWaiting();
  }

  update(event) {
    const { selected, blocked, balance, amount, beneficiary, iban, bic } = event.detail;

    if (!selected || blocked) {
      this.#showWaiting();
      return;
    }

    this.waitingTarget.classList.add('d-none');
    this.walletBalanceTarget.classList.add('d-none');
    this.bankTransferTarget.classList.add('d-none');

    if (amount <= 0) {
      this.walletAmountTarget.textContent = convertToCurrency(balance);
      this.walletBalanceTarget.classList.remove('d-none');
      return;
    }

    const walletDebit = Math.min(balance, amount);
    const transferAmount = Math.max(amount - balance, 0);

    if (walletDebit > 0) {
      this.walletAmountTarget.textContent = convertToCurrency(walletDebit);
      this.walletBalanceTarget.classList.remove('d-none');
    }

    if (transferAmount > 0) {
      this.#fillBankTransfer({ transferAmount, beneficiary, iban, bic });
      this.bankTransferTarget.classList.remove('d-none');
    }
  }

  #showWaiting() {
    this.walletBalanceTarget.classList.add('d-none');
    this.bankTransferTarget.classList.add('d-none');
    this.waitingTarget.classList.remove('d-none');
  }

  #fillBankTransfer({ transferAmount, beneficiary, iban, bic }) {
    this.transferAmountTarget.textContent = convertToCurrency(transferAmount);
    this.transferBeneficiaryTarget.textContent = beneficiary;
    this.transferIbanTarget.textContent = iban;
    this.transferBicTarget.textContent = bic;

    this.beneficiaryCopyTarget.dataset.copyCopyTextValue = beneficiary;
    this.ibanCopyTarget.dataset.copyCopyTextValue = iban;
    this.bicCopyTarget.dataset.copyCopyTextValue = bic;
  }
}
